import ForgotPasswordRequest from "../domain/ForgotPasswordRequest";
import WsService from "./WsService";
import MsisdnSearchStripper from "../utils/MsisdnSearchStripper";

const ENDPOINT_BASE = "/authentication";

export default class ForgotPasswordService {
    static forgotPassword(username) {

        let endpoint = ENDPOINT_BASE + "/forgot-password";

        if(!username.toString().includes('@')){
            username = MsisdnSearchStripper.stripMsisdn(username)
        }
        let resetRequest = ForgotPasswordRequest.toJson(username);
        let headers = {
            "Authorization" : ""
        };

        return WsService.postWithHeaders(endpoint, resetRequest, 200, headers).then(
            response => {
                return 'success';
            },
            response => {
                return response;
            }
        )
    }
}